import PATHS from '../constants';

function fetchServiceDetails(id) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.SERVICE_DETAILS(id), {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchServiceDetails;